import React, { useState, useEffect, useCallback } from 'react';
import { Label, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { useLazyQuery, useQuery } from '@apollo/client';
import Select from 'react-select';

import { GET_CLIENTS_PAGE } from '../../../store/queries/clients';

import { debounce } from 'lodash';

function SelectClients({
  user,
  ismulti,
  disable,
  value,
  parentCallback,
  label,
  placeholder = 'Digite para pesquisar...'
}) {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [searchClients, { loading, data }] = useLazyQuery(GET_CLIENTS_PAGE); // Substitua pelo nome correto da sua query

  const debouncedSearch = debounce(value => {
    if (value.length >= 3) {
      searchClients({
        variables: {
          name: value,
          customer: user.customer,
          perPage: 20,
          page: 0
        }
      });
    }
  }, 300);

  useEffect(() => {
    const timerId = setTimeout(() => {
      debouncedSearch(inputValue);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [debouncedSearch, inputValue]);

  useEffect(() => {
    if (data && data.clientsPage) {
      setOptions(
        data.clientsPage.docs.map(client => ({
          value: client._id,
          label: client.name
        }))
      );
    }
  }, [data]);

  useEffect(() => {
    if (data && data.clientsPage) {
      setOptions(
        data.clientsPage.docs.map(client => ({
          value: client._id,
          label: client.name
        }))
      );
    }
  }, [data]);
  return (
    <FormGroup>
      <Label for='exampleSelect'>{label}</Label>
      <Select
        value={value}
        input
        isMulti={ismulti}
        isSearchable={true}
        onInputChange={newInputValue => setInputValue(newInputValue)}
        onChange={e => parentCallback(e)}
        placeholder={(loading && 'Buscando clientes...') || placeholder}
        options={options}
        isLoading={loading}
        // closeMenuOnSelect={ismulti ? false : true}
        noOptionsMessage={() => 'Comece a digitar para pesquisar um cliente'}
        styles={{
          backgroundColor: 'blue',
          menu: provided => ({ ...provided, zIndex: 900 })
        }}
      />
    </FormGroup>
  );
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(SelectClients);
